import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProxyService {

  constructor(private http: HttpClient) {}

  // ── Proxy ──────────────────────────────────────────────

  queryProxies(query: any): Observable<any> {
    let params = new HttpParams();
    if (query.queryString) params = params.set('QueryString', query.queryString);
    if (query.sourceId) params = params.set('SourceId', query.sourceId);
    if (query.status !== null && query.status !== undefined) params = params.set('Status', query.status);
    if (query.protocol) params = params.set('Protocol', query.protocol);
    if (query.availableForMerchantType) params = params.set('AvailableForMerchantType', query.availableForMerchantType);
    if (query.sortBy) params = params.set('SortBy', query.sortBy);
    if (query.sortType) params = params.set('SortType', query.sortType);
    params = params.set('PageSize', query.pageSize || 20);
    params = params.set('PageNumber', query.pageNumber || 1);
    return this.http.get<any>('/api/Proxy/Query', { params });
  }

  getProxy(id: string): Observable<any> {
    return this.http.get<any>('/api/Proxy/GetProxy', { params: { id } });
  }

  importProxies(request: any): Observable<any> {
    return this.http.post<any>('/api/Proxy/ImportProxies', request);
  }

  saveProxy(proxy: any): Observable<any> {
    return this.http.post<any>('/api/Proxy/SaveProxy', proxy);
  }

  deleteProxy(id: string): Observable<any> {
    return this.http.post<any>('/api/Proxy/DeleteProxy', { id });
  }

  exportProxies(ids: string[]): Observable<any> {
    return this.http.post<any>('/api/Proxy/ExportProxies', { ids });
  }

  extendProxies(request: { ids: string[], lines?: string, days: number, costUsd: number }): Observable<any> {
    return this.http.post<any>('/api/Proxy/ExtendProxies', request);
  }

  // ── Usage ──────────────────────────────────────────────

  addUsage(usage: any): Observable<any> {
    return this.http.post<any>('/api/Proxy/AddUsage', usage);
  }

  updateUsage(usage: any): Observable<any> {
    return this.http.post<any>('/api/Proxy/UpdateUsage', usage);
  }

  deleteUsage(id: string): Observable<any> {
    return this.http.post<any>('/api/Proxy/DeleteUsage', { id });
  }

  // ── Proxy Source ───────────────────────────────────────

  querySources(query: any): Observable<any> {
    let params = new HttpParams();
    if (query.queryString) params = params.set('QueryString', query.queryString);
    params = params.set('PageSize', query.pageSize || 50);
    params = params.set('PageNumber', query.pageNumber || 1);
    return this.http.get<any>('/api/ProxySource/Query', { params });
  }

  saveSource(source: any): Observable<any> {
    return this.http.post<any>('/api/ProxySource/Save', source);
  }

  deleteSource(id: string): Observable<any> {
    return this.http.post<any>('/api/ProxySource/Delete', { id });
  }

  // ── Merchants (for usage dropdown) ─────────────────────

  getMerchants(): Observable<any> {
    return this.http.get<any>('/api/Merchant/QueryMerchants', {
      params: { PageSize: '500', PageNumber: '1', IncludeDeleted: 'false' }
    });
  }
}
